import { toast } from "react-toastify";

interface CheckoutRequiredData {
  location?: string | null;
  employed_at?: string | null;
  budget_range?: string | null;
}

export const getMissingCheckoutFields = (data?: CheckoutRequiredData | null) => {
  const missing: string[] = [];
  if (!data?.location) missing.push("Location");
  if (!data?.employed_at) missing.push("Employed at/self employed");
  if (!data?.budget_range) missing.push("Budget");
  return missing;
};

const joinFields = (fields: string[]) =>
  fields.length > 1
    ? `${fields.slice(0, -1).join(", ")} and ${fields[fields.length - 1]}`
    : fields[0];

export const showMissingCheckoutFieldsToast = (
  missing: string[],
  opportunityId: string,
  onUpdateDetails: () => void
) => {
  toast.error(
    ({ closeToast }) => (
      <div>
        <div>{`Please update ${joinFields(missing)} before checking out.`}</div>
        <button
          style={{
            marginTop: 8,
            padding: "4px 12px",
            border: "none",
            borderRadius: 4,
            cursor: "pointer",
            fontWeight: 600,
          }}
          onClick={() => {
            closeToast?.();
            onUpdateDetails();
          }}
        >
          Update details
        </button>
      </div>
    ),
    { toastId: `checkout-missing-fields-${opportunityId}` }
  );
};
